const OrderFieldClearButton = ({ show, withInfo = false, onClear, label }) => {
  if (!show) return null
  return (
    <button
      type="button"
      className={`order-field-clear-button ${withInfo ? 'has-info' : ''}`}
      onClick={onClear}
      title={label}
      aria-label={label}
    >
      <i className="bi bi-x-lg"></i>
    </button>
  )
}

export default OrderFieldClearButton
